module.exports = __webpack_public_path__ + "img/case.4a8ba77.png";